import React, { createContext, type PropsWithChildren, useContext } from 'react';

import { type TeamContainerType, type TeamData } from '../../ui/team-selector/types';

export type TeamSelectorContextType = {
	cloudId: string;
	orgId: string;
	containerId: string;
	containerType?: TeamContainerType;
	onUpdateSuccess?: (params: { teamsConnected: TeamData[]; teamsDisconnected: TeamData[] }) => void;
};

const TeamSelectorContext = createContext<TeamSelectorContextType>({
	cloudId: '',
	orgId: '',
	containerId: '',
});

export function TeamSelectorProvider({
	children,
	cloudId,
	orgId,
	containerId,
	containerType,
	onUpdateSuccess,
}: PropsWithChildren<TeamSelectorContextType>): React.JSX.Element {
	return (
		<TeamSelectorContext.Provider
			value={{
				cloudId,
				orgId,
				containerId,
				containerType,
				onUpdateSuccess,
			}}
		>
			{children}
		</TeamSelectorContext.Provider>
	);
}

export const useTeamSelectorContext = () => useContext(TeamSelectorContext);
